var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "overflow-hidden" },
    [
      _c(
        "v-app-bar",
        {
          staticClass: "px-sm text-left shadow-sm",
          staticStyle: { "background-color": "#424242 !important" },
          attrs: {
            dark: _vm.$vuetify.theme.dark,
            flat: "",
            height: "200",
            absolute: "",
            prominent: "",
          },
        },
        [
          _c(
            "v-container",
            { staticClass: "d-flex align-center mt-6" },
            [
              _c("v-progress-linear", {
                attrs: {
                  active: _vm.getThemeMode.isLoading,
                  indeterminate: _vm.getThemeMode.isLoading,
                  absolute: "",
                  bottom: "",
                  color: "primary",
                },
              }),
              _c(
                "v-toolbar-title",
                { staticStyle: { "margin-top": "-20px" } },
                [
                  _c("v-avatar", { attrs: { height: "95", width: "95" } }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/logo.svg"),
                        alt: "avatar",
                      },
                    }),
                  ]),
                ],
                1
              ),
              _c("v-spacer"),
              _c(
                "v-menu",
                {
                  attrs: { "offset-y": "", "min-width": "150" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on, attrs }) {
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                { attrs: { color: "", dark: "", icon: "" } },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _c("v-avatar", { attrs: { size: "30" } }, [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/avatars/001-man.svg"),
                                    alt: "",
                                  },
                                }),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "v-list",
                    [
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-list-item-title",
                            [
                              _c("v-avatar", { attrs: { size: "80" } }, [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/avatars/001-man.svg"),
                                    alt: "",
                                  },
                                }),
                              ]),
                              _vm._v(" " + _vm._s(_vm.nameuser) + " "),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-list-item-title",
                            [
                              _c(
                                "v-button",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  on: { click: _vm.signOut },
                                },
                                [
                                  _c("v-icon", { staticClass: "mr-1" }, [
                                    _vm._v(" mdi-logout "),
                                  ]),
                                  _vm._v("Cerrar Sesión "),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        {
                          directives: [
                            {
                              name: "can",
                              rawName: "v-can",
                              value: "Roles Y Permisos",
                              expression: "'Roles Y Permisos'",
                            },
                          ],
                        },
                        [
                          _c(
                            "v-list-item-title",
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "no-decoration",
                                  attrs: { to: "/app/user/roles-permisos" },
                                },
                                [
                                  _c(
                                    "v-button",
                                    { staticStyle: { cursor: "pointer" } },
                                    [
                                      _c("v-icon", { staticClass: "mr-1" }, [
                                        _vm._v("mdi mdi-cog-transfer-outline"),
                                      ]),
                                      _vm._v(" Roles - Permisos "),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }